import { Component, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Group } from '../../../../model/Group';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AccountPageService } from '../../../../service/account-page.service';
import { ToastrService } from 'ngx-toastr';
import { DarkModeService } from '../../../../service/dark-mode.service';

@Component({
  selector: 'ch-update-group',
  templateUrl: './update-group.component.html'
})
export class UpdateGroupComponent implements OnInit {

  group: Group;
  updateGroupForm: UntypedFormGroup;
  groupUpdateEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor(private readonly fb: UntypedFormBuilder,
              private readonly accountService: AccountPageService,
              private readonly toastrService: ToastrService,
              public readonly darkModeService: DarkModeService,
              public readonly modalRef: BsModalRef) {
  }

  ngOnInit(): void {
    this.updateGroupForm = this.fb.group({
      id: new UntypedFormControl({value: this.group.id, disabled: true}),
      name: new UntypedFormControl(this.group.name)
    });
  }

  update() {
    this.accountService.updateGroup(this.updateGroupForm.getRawValue()).subscribe(() => {
      this.modalRef.hide();
      this.groupUpdateEvent.emit();
    }, err => {
      console.log(err);
      this.toastrService.error(err.error);
    });
  }

}
